module.exports = __webpack_public_path__ + "static/feladatkiadas_mobil1-07755db1f279480c30211d97521a7c23.png";